module.exports = __webpack_public_path__ + "img/PoweredLogo_color.36aed544.svg";